import { useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';

import { getListApiKeysQueryKey, useDeleteApiKey } from '@/modules/api/codegen';
import { actions as messagesActions } from '@/modules/messages';

export const useRevokeApiKey = () => {
    const dispatch = useDispatch();
    const queryClient = useQueryClient();

    return useDeleteApiKey({
        mutation: {
            onSuccess: async () => {
                await queryClient.invalidateQueries({ queryKey: getListApiKeysQueryKey() });

                dispatch(
                    messagesActions.displaySuccessMessage({
                        message: { id: 'api-keys.revoke.success' },
                        options: { duration: 5 },
                    }),
                );
            },
            onError: () =>
                dispatch(
                    messagesActions.displayErrorMessage({
                        message: { id: 'api-keys.revoke.error' },
                        options: { duration: 5 },
                    }),
                ),
        },
    });
};
